export default function AdminDashboardPage() {
  return (
    <div>
      <h2 className="text-2xl font-bold text-gray-900">Administration</h2>
      <p className="mt-4 text-gray-600">Vue d'ensemble administrative.</p>
    </div>
  );
}
